var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplicationsWaitlisted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "file_13_",
    "data-name": "file (13)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.982,
    height: 55.197,
    viewBox: "0 0 54.982 55.197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_46614",
    "data-name": "Path 46614",
    d: "M411,8.782v9.834h9.833Z",
    transform: "translate(-366.799 -7.835)",
    fill: "#64b5f6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46615",
    "data-name": "Path 46615",
    d: "M150.647,14.015A1.617,1.617,0,0,1,149.03,12.4V0H125.851A4.857,4.857,0,0,0,121,4.851V22.929c.533-.048,1.072-.074,1.617-.074a17.76,17.76,0,0,1,13.712,6.468h17.553a1.617,1.617,0,1,1,0,3.234H138.459a17.653,17.653,0,0,1,1.872,6.468h13.55a1.617,1.617,0,1,1,0,3.234h-13.55a17.8,17.8,0,0,1-7.5,12.937h25.361a4.857,4.857,0,0,0,4.851-4.851V14.015Zm3.234,8.84H130.164a1.617,1.617,0,1,1,0-3.234h23.718a1.617,1.617,0,1,1,0,3.234Z",
    transform: "translate(-108.063)",
    fill: "#64b5f6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46616",
    "data-name": "Path 46616",
    d: "M15.554,242a14.554,14.554,0,1,0,14.554,14.554A14.57,14.57,0,0,0,15.554,242Zm4.312,16.171H15.554a1.617,1.617,0,0,1-1.617-1.617v-6.468a1.617,1.617,0,0,1,3.234,0v4.851h2.7a1.617,1.617,0,1,1,0,3.234Z",
    transform: "translate(-1 -215.911)",
    fill: "#eed813"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationsWaitlisted);
export default __webpack_public_path__ + "static/media/applications-waitlisted.c2d4d9ce7923be7e2f474e651b495687.svg";
export { ForwardRef as ReactComponent };